import React, {useContext, useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config';
import axios from 'axios';
import useNotification from '../../../hooks/useNotification';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function PanelsStatusSetStatusModel(props) {
    const auth = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [radioStatus, setRadioStatus] = useState("Y");
    const { notificationSuccess, notificationError, notificationWarning } = useNotification();

    useEffect(() => {
        console.log(props.lastCellData?.panelStatus);
        setRadioStatus(props.lastCellData?.panelStatus);
    },[props.openPanelSetStatusDialog])

    const modManualStatus = async() => {
        try {
            setLoading(true);
        
            if(!props.lastCellData.idEntita)return;

            const data = {
                status: radioStatus === props.lastCellData.panelStatus ? '' : radioStatus
            }
            
            const dataToPass = {
                idEntita: props.lastCellData.idEntita,
                city: props.lastCellData.city,
                ExpressionAttributeNames: {},
                ExpressionAttributeValues: {},
                UpdateExpression: "SET",
            };
            
            let dataKeys = Object.keys(data);
            for (let index = 0; index < dataKeys.length; index++) {
                const element = dataKeys[index];
                
                if(!data[element]){
                    delete data[element];
                }else if(element === 'groupList' || element === 'bannerList'){
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"SS": data[element].length === 0 ? [""] :[...data[element]]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`; 
                }else{
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"S": data[element]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`;
                }
            }

            if(!Object.keys(data).length){
                //se non ci sono chiavi non è cambiato nulla e ritorno
                return;
            }

            const axiosParams = {
                url: '/mod-panel',
                method: 'post',
                baseURL: config.API_URL,
                headers: {
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: dataToPass
            };

            await axios(axiosParams);
            notificationSuccess('Status Modificato');

            await props.getMonitoringData();
            props.handleClosePanelSetStatusDialog();
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLoading(false);
        }
    }

    return (
        <Dialog className="" open={props.openPanelSetStatusDialog} onClose={props.handleClosePanelSetStatusDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{props?.lastCellData?.key}</DialogTitle>
            <DialogContent>

                <FormControl>
                    <FormLabel id="status-radio">Status</FormLabel>
                    <RadioGroup
                        aria-labelledby="status-radio"
                        name="radio-buttons-group"
                        value={radioStatus}
                        onChange={(event) => {
                            setRadioStatus(event.target.value);
                        }}
                    >
                        <FormControlLabel value="Y" control={<Radio />} label="Attivo" />
                        <FormControlLabel value="G" control={<Radio />} label="Guasto" />
                    </RadioGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" disabled={radioStatus === props?.lastCellData?.panelStatus} onClick={modManualStatus}>
                    Salva
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleClosePanelSetStatusDialog}>
                    Annulla
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default PanelsStatusSetStatusModel